import type { AdminPermission, AdminRole, LedgerType, ResultUrlMode, StorageBackend } from '@aitoken/contracts';

export const LEDGER_TYPE_LABEL: Record<LedgerType, string> = {
  grant: '录入额度',
  deduct: '扣减',
  reversal: '冲正',
  reserve: '冻结',
  release: '释放',
  settle: '结算',
  waive: '免单',
  commission: '推荐佣金',
  refund: '任务退款',
  topup: '充值',
  topup_bonus: '充值赠送',
  redeem: '兑换码',
};

export const FAILURE_CODE_LABEL: Record<string, string> = {
  no_available_channel: '无可用渠道',
  upstream_status_unknown: '上游状态未知',
  task_deadline_exceeded: '超出任务时限',
  content_rejected: '内容审核拒绝',
  asset_rejected: '素材被拒',
  invalid_parameter: '参数错误',
  account_suspended: '账号已停用',
  result_unavailable: '结果不可用',
  internal_error: '内部错误',
  quota_exceeded: '额度不足',
};

/** 失败分布中属于“客户侧真实失败”（非平台技术失败）的分类，单独着色，不与技术失败混在一起 */
export const CUSTOMER_SIDE_FAILURES = new Set([
  'content_rejected',
  'asset_rejected',
  'invalid_parameter',
  'account_suspended',
  'quota_exceeded',
]);

export const ALERT_TYPE_LABEL: Record<string, string> = {
  channel_down: '渠道失效',
  channel_failure: '渠道失效',
  balance_low: '余额/权益不足',
  entitlement_expiring: '权益即将到期',
  asset_sync_failed: '素材同步失败',
  backlog: '任务积压',
  reserve_expired: '冻结过期',
  delivery_failed: '交付异常',
  webhook_failed: '回调投递失败',
};

export const SEVERITY_LABEL: Record<string, string> = {
  critical: '严重',
  warning: '警告',
  info: '提示',
};

export const PROVIDER_LABEL: Record<string, string> = {
  volcengine_ark: '火山方舟',
  byteplus_modelark: 'BytePlus ModelArk',
  modelland: 'Modelland',
  mock: '本地 Mock',
};

export const ROLE_LABEL: Record<AdminRole, string> = {
  operator: '运营',
  sysadmin: '系统管理员',
};

export const PERMISSION_LABEL: Record<AdminPermission, string> = {
  'dashboard.read': '查看总览',
  'user.read': '查看用户',
  'user.write': '管理用户',
  'quota.write': '额度操作',
  'model.write': '模型管理',
  'price.write': '价格管理',
  'channel.read': '查看渠道',
  'channel.write': '渠道管理',
  'channel.credential.write': '写入凭证',
  'asset.read': '查看素材',
  'asset.raw.view': '查看原始素材',
  'task.read': '查看任务',
  'task.operate': '任务操作',
  'alert.write': '处理告警',
  'audit.read': '查看审计',
  'admin.manage': '管理员管理',
  'settings.write': '站点设置',
};

export const MODE_LABEL: Record<string, string> = {
  text_to_video: '文生视频',
  first_frame: '首帧',
  first_last_frame: '首尾帧',
  reference: '参考生成',
};

export const SEARCH_TYPE_LABEL: Record<string, string> = {
  user: '用户',
  task: '任务',
  asset: '素材',
  ledger: '流水',
};

export function failureLabel(code: string | null | undefined): string {
  if (!code) return '—';
  return FAILURE_CODE_LABEL[code] ?? code;
}

export const STORAGE_BACKEND_LABEL: Record<StorageBackend, string> = {
  r2: 'Cloudflare R2',
  tos: '火山引擎 TOS',
};

export const RESULT_URL_MODE_LABEL: Record<ResultUrlMode, string> = {
  platform: '只给平台链接',
  upstream: '只给上游原链接',
  both: '平台链接 + 上游原链接',
};

